import { useEffect, useMemo, useState } from 'react';

export const DEFAULT_BUCKETS = ['not_due', 'due_0_30', 'due_31_60', 'due_61_90', 'due_over_90'];
export const OVERDUE_BUCKETS = ['due_0_30', 'due_31_60', 'due_61_90', 'due_over_90'];

const DEFAULT_FILTERS = {
    buckets: DEFAULT_BUCKETS,
    level: '',
    dueFrom: '',
    dueTo: '',
    customer: '',
};

export default function useOpenInvoiceFilters(initialFilters = null) {
    const resolvedInitialFilters = useMemo(() => {
        if (!initialFilters || typeof initialFilters !== 'object') {
            return DEFAULT_FILTERS;
        }
        return {
            ...DEFAULT_FILTERS,
            ...initialFilters,
            buckets: Array.isArray(initialFilters.buckets) ? initialFilters.buckets : DEFAULT_BUCKETS,
        };
    }, [initialFilters]);

    const [filters, setFilters] = useState(resolvedInitialFilters);
    const [appliedFilters, setAppliedFilters] = useState(filters);

    useEffect(() => {
        setFilters(resolvedInitialFilters);
        setAppliedFilters(resolvedInitialFilters);
    }, [resolvedInitialFilters]);

    const handleFilterChange = (key) => (event) => {
        const value = event.target.value;
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    const handleDateChange = (key) => (date) => {
        setFilters((prev) => ({ ...prev, [key]: date }));
    };

    const applyFilters = () => {
        setAppliedFilters({ ...filters });
    };

    const resetFilters = () => {
        const reset = DEFAULT_FILTERS;
        setFilters(reset);
        setAppliedFilters(reset);
    };

    return {
        filters,
        appliedFilters,
        handleFilterChange,
        handleDateChange,
        applyFilters,
        resetFilters,
    };
}
